import { useEffect, useRef } from 'react';

export default function useEventListener(eventName, handler, element) {
  // Create a ref that stores handler
  const savedHandler = useRef(undefined);
  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(
    () => {
      // Make sure element supports addEventListener
      // On
      const target = element?.current || window;
      const isSupported = target && target.addEventListener;
      if (!isSupported) return;

      // Create event listener that calls handler function stored in ref
      const eventListener = (event) => {
        if (!savedHandler) return;
        savedHandler.current(event);
      };

      // Add event listener
      target.addEventListener(eventName, eventListener);
      // Remove event listener on cleanup
      return () => {
        target.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element?.current], // Re-run if eventName or element changes
  );
}
